import theme from 'library/theme/theme';
import styled from 'styled-components';

export const Container = styled.div`
  text-align: center;
  color: ${theme.palette.primary.main};
`;
